import { render, staticRenderFns } from "./SpcmStudentUniversityRecov1.vue?vue&type=template&id=2ac3e956"
import script from "./SpcmStudentUniversityRecov1.vue?vue&type=script&lang=js"
export * from "./SpcmStudentUniversityRecov1.vue?vue&type=script&lang=js"
import style0 from "./SpcmStudentUniversityRecov1.vue?vue&type=style&index=0&id=2ac3e956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports